export default __webpack_public_path__ + "static/media/trafic-gallery-6.ae173267.jpg";